// extracted by mini-css-extract-plugin
export default {"commentCard":"user-comments-skeleton_commentCard__DIdyI"};